// extracted by mini-css-extract-plugin
module.exports = {"aboutMe":"AboutMe_aboutMe__3DLWc","commonInf":"AboutMe_commonInf__3LDiI"};